import React from 'react';
import { useCookies } from 'react-cookie';
import SerieFreePriceContext from '.';
import { PriceSerieFreeBoxVariable } from '../../../data';

export default function SerieFreePriceContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const [cookies, setCookie] = useCookies([`wysiwyg.resiliation-fee.offer.${PriceSerieFreeBoxVariable.id}`]);
  const cookieValue = cookies[`wysiwyg.resiliation-fee.offer.${PriceSerieFreeBoxVariable.id}`];
  const firstYear = cookieValue ? parseFloat(cookieValue) : 10.99;

  const value = React.useMemo(() => ({
    updatePrice(newValue: number) {
      setCookie(`wysiwyg.resiliation-fee.offer.${PriceSerieFreeBoxVariable.id}`, newValue, { path: '/' });
    },
    price: firstYear,
  }), [cookieValue]);

  return (
    <SerieFreePriceContext.Provider value={value}>
      {children}
    </SerieFreePriceContext.Provider>
  );
}
